<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Salário Mínimo - {{salarioMinimo.codSalarioMinimo != null ? 'Editar' : 'Incluir'}}</h1>
        <b-card>
            <b-row class="mb-0">
                <b-col sm="12" md="3" class="mb-0">
                    <b-form-group
                        label="Valor (R$):"
                        label-for="valor"
                        class="text-label required">
                        <b-form-input v-model="salarioMinimo.valor" type="text" id="valor" @change="validarValor"
                                      :class="!validations.valor.valid ? 'is-invalid' : ''"
                                      @keyup="salarioMinimo.valor = formatarMonetario(salarioMinimo.valor)"
                                      @blur="salarioMinimo.valor = adicionarCasas(salarioMinimo.valor)"/>
                        <div v-if="!validations.valor.valid" class="invalid-message">Valor inválido!</div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0">
                <b-col sm="12" md="3" class="mt-3">
                    <b-form-group
                        label="Início da vigência:"
                        label-for="dataInicioVigencia"
                        class="text-label required">
                        <b-form-input
                            v-model="salarioMinimo.dataInicioVigencia"
                            :class="!validations.dataInicioVigencia.valid ? 'is-invalid' : ''"
                            id="dataInicioVigencia"
                            max="9999-12-31"
                            name="dataInicioVigencia"
                            @blur="validarDataInicioVigencia"
                            type="date"/>
                        <div v-if="!validations.dataInicioVigencia.valid" class="invalid-message">Data inválida!</div>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
                id="modal-voltar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Voltar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="salarioMinimo.codSalarioMinimo != null">Deseja retornar à tela anterior sem salvar as alterações?</p>
                    <p style="font-weight: bold;" v-if="salarioMinimo.codSalarioMinimo == null">Deseja retornar à tela anterior sem salvar o cadastro?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-voltar')"> Não</b-button>
                <b-button variant="primary" @click="voltar"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-salvar"
                id="modal-salvar"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Salvar"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;" v-if="salarioMinimo.codSalarioMinimo != null">Deseja salvar as alterações?</p>
                    <p style="font-weight: bold;" v-if="salarioMinimo.codSalarioMinimo == null">Deseja salvar o cadastro?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-salvar')"> Não</b-button>
                <b-button variant="primary" @click="salvar"> Sim</b-button>
            </template>
        </b-modal>
        <hr class="mt-2"/>
        <b-row class="center-xy">
            <b-button variant="outline-secondary" v-b-modal.modal-voltar>
                <i class="fa fa-reply"></i> Voltar
            </b-button>
            <b-button variant="primary" class="ml-2" @click="clicarSalvar()" :disabled="validarSalvar()">
                <i class="far fa-save"></i> Salvar
            </b-button>
        </b-row>
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import axios from 'axios'
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';
    import moment from 'moment';

    export default {
        components: {CompLoading},
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                salarioMinimo: {
                    codSalarioMinimo: null,
                    valor: null,
                    dataInicioVigencia: null
                },
                validations: {
                    valor: { valid: true },
                    dataInicioVigencia: { valid: true }
                }
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            },
        },
        methods: {
            validarSalvar() {
                return this.verificarValorVazio(this.salarioMinimo.valor) ||
                    this.verificarValorVazio(this.salarioMinimo.dataInicioVigencia);
            },
            clicarSalvar() {
                this.$store.commit("setMessages", {});

                if(this.verificarObrigatoriedade()) {
                    return;
                } else {
                    this.$refs['modal-salvar'].show();
                }
            },

            salvar() {
                this.$refs['modal-salvar'].hide();

                let salarioMinimoSalvar = {
                    ...this.salarioMinimo,
                    valor: this.tratarCamposNumericos(this.salarioMinimo.valor)
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/salarioMinimo`, salarioMinimoSalvar, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.$store.commit("setMsgCrud", 'Operação realizada com sucesso!!!');
                    this.$router.push({path: '/salario-minimo'});
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            verificarObrigatoriedade() {
                this.validarValor();
                this.validarDataInicioVigencia();
                return !this.validations.valor.valid ||
                    !this.validations.dataInicioVigencia.valid;
            },

            voltar(evt) {
                evt.preventDefault();
                this.$router.push({path: '/salario-minimo'});
            },

            async obterSalarioMinimo(codSalarioMinimo) {
                await axios.get(`${this.urlApi}/v1/salarioMinimo/` + codSalarioMinimo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.salarioMinimo = {
                        ...response.data
                    };

                    let valor = null;
                    if(this.salarioMinimo.valor != null) {
                        valor = this.salarioMinimo.valor.toString();
                        if(valor.split(".").length <= 1) {
                            valor += "00";
                        } else if(valor.split(".")[1].length == 1) {
                            valor += "0";
                        }
                    }
                    this.salarioMinimo.valor = this.formatarMonetario(valor);
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            validarValor() {
                let valor = this.tratarCamposNumericos(this.salarioMinimo.valor)
                if(valor <= 0) {
                    this.validations.valor.valid = false;
                } else {
                    this.validations.valor.valid = true;
                }
            },

            validarDataInicioVigencia() {
                if(!moment(this.salarioMinimo.dataInicioVigencia).isValid()) {
                    this.validations.dataInicioVigencia.valid = false;
                } else {
                    this.validations.dataInicioVigencia.valid = true;
                }
            },
            acionarEnterDelay(e) {
                setTimeout(()=>{
                    this.acionarEnter(e);
                }, 200);
            },
            acionarEnter(e) {
                if(e.key == 'Enter' && !this.validarSalvar()) {
                    this.clicarSalvar();
                }
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let salarioMinimoEditado = this.$store.getters.getSalarioMinimo;
            if(salarioMinimoEditado) {
                this.$store.commit('setSalarioMinimo', null);
                this.obterSalarioMinimo(salarioMinimoEditado);
            }

            window.addEventListener("keypress", this.acionarEnterDelay);
        }
    }
</script>
